export default function BannerText({ children, className }) {
	return (
		<p
			className={className}
			style={{
				fontWeight: 800,
				color: 'rgba(254,253,240,1)',
				WebkitTextStroke: '0.09em rgba(149,71,36,1)',
				paintOrder: 'stroke fill',
				textAlign: 'center',
				filter: `
				drop-shadow(0 0.045em 0 rgba(133,74,14,1))
				drop-shadow(0 0.09em 0.09em rgba(133,74,14,0.9))
				drop-shadow(0 0.14em 0.18em rgba(133,74,14,0.6))
			`,
				margin: 0,
			}}
		>
			{children}
		</p>
	)
}